import React from 'react'
import Back from '../common/Back'
import TestimonialCard from './TestimonialCard'

const Testimonial = () => {
    return (
        <>
            <Back title='Testimonial'/>
            <TestimonialCard />
        </>
    )
}

export default Testimonial
